import { attemptToGetAuthToken } from '../utils/auth'
import { isProduction } from '../utils/environment'

export const fetcher = <TData, TVariables extends Record<string, unknown>>(
	query: string,
	variables?: TVariables,
	options?: RequestInit['headers'],
): ( () => Promise<TData> ) => {
	const apiUrl = isProduction()
		? 'https://fleet-integrations-api.equipmentshare.com/graphql'
		: 'https://staging-fleet-integrations-api.equipmentshare.com/graphql'

	return async() => {
		const { jwt: BEARER_TOKEN } = await attemptToGetAuthToken()
		const response = await fetch( apiUrl, {
			method: 'POST',
			headers: {
				'Authorization': `Bearer ${BEARER_TOKEN}`,
				'Content-Type': 'application/json',
				...options,
			},
			body: JSON.stringify( { query, variables } ),
		} )

		if ( !response.ok ) {
			const error = new Error( `Network response was not ok: ${response.statusText}` ) as Error & { statusCode?: number }
			error.statusCode = response.status
			throw error
		}

		const json = await response.json()

		if ( json.errors?.length ) {
			const errorMessage = json.errors.map( ( error: { message: string } ) => error.message ).join( ', ' )
			throw new Error( errorMessage )
		}

		return json.data as TData
	}
}
